import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Inbox, LucideAngularModule } from 'lucide-angular';

@Component({
  selector: 'app-empty-state',
  imports: [CommonModule, LucideAngularModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="rounded-lg border border-border p-8 text-center">
      <lucide-icon class="w-12 h-12 text-gray-300 mx-auto mb-4" [name]="inboxIcon" />
      <h3 class="text-lg font-medium text-text-secondary mb-2">{{ title() }}</h3>
      <p class="text-text-secondary">{{ message() }}</p>
    </div>
  `,
})
export class EmptyStateComponent {
  readonly title = input<string>('No data available');
  readonly message = input<string>('There is nothing to display at the moment.');

  readonly inboxIcon = Inbox;
}
